import React, { useEffect, useState } from "react";
import PaymentInformationForm from "./PaymentInformationForm";
import { RecurlyElements } from "@/components/RecurlyElements";
import PlanLayout from "../PlanLayout";
import { getPlan } from "@/api/billing";
import { useSearch } from "wouter";
import { RecurlyPlan } from "@/lib/recurly";
import PageLoader from "@/components/PageLoader";

export default function PaymentInformationPage() {
  const searchParams = new URLSearchParams(useSearch());

  const [plan, setPlan] = useState<RecurlyPlan | null>(null);

  useEffect(() => {
    getPlan(searchParams.get("plan")).then(planRes => setPlan(planRes));
  }, [])

  if (!plan) {
    return <PageLoader />
  }

  return <>
    <PlanLayout plan={plan}>
      <RecurlyElements>
        <PaymentInformationForm plan={plan} />
      </RecurlyElements>
    </PlanLayout>
  </>;
}
